
const aprobarSolicitudes = {
  isLoading: false,
  solicitudes: [],
}

export default aprobarSolicitudes;
